import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
// import { Icon } from 'tea-component';
import { getCollapseStateSwitchBtnConfig } from '@gp/components/CollapseStateSwitchBtn/utils';
import '@gp/components/CollapseStateSwitchBtn/index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

/**
 * 折叠状态切换按钮组件
 * collapsedText 折叠状态下的按钮文案
 * expandedText 展开状态下的按钮文案
 * value 是否折叠
 * onChange 折叠状态切换回调
 */
const GPCollapseStateSwitchBtn: React.FC<ICollapseStateSwitchBtnProps> = (
  props,
) => {
  const {
    collapsedText = 'Unfold',
    expandedText = 'Fold',
    value,
    onChange,
    style,
    className,
    ...remains
  } = props;

  const config = useMemo(
    () => getCollapseStateSwitchBtnConfig(value, collapsedText, expandedText),
    [value, collapsedText, expandedText],
  );

  return (
    <span
      {...remains}
      style={style}
      className={classnames('gp-common-collapse-state-switch-btn', className)}
      onClick={(e) => {
        onChange?.(!value, e);
      }}
    >
      <span>{config?.btnText}</span>
      <SvgIcon
        type={config?.iconType}
        className="gp-common-collapse-state-switch-btn-icon"
      />
    </span>
  );
};

export default memo(GPCollapseStateSwitchBtn);
